import React, { lazy } from 'react';

import { Icon } from '@poliedro/tamentai';

export interface RouteConfig {
  path: string;
  name?: string;
  parent: string | null;
  element: React.ReactElement;
  label?: string;
  icon?: React.ReactElement;
  showInNavBar?: boolean;
  feature?: 'avaliar' | 'personalizar' | 'planejar' | 'analisar';
  blockedForProfiles?: string[];
}

const Home = lazy(() => import('../pages/Home'));
const ListPEI = lazy(() => import('../pages/NovoPei/components/List'));
const Chat = lazy(() => import('../pages/Chat'));
const History = lazy(() => import('../pages/History'));
const RelatorioEnem = lazy(() => import('../pages/RelatorioEnem'));
const ErrorPage = lazy(() => import('../pages/ErrorPage/index'));
const NewPEI = lazy(() => import('../pages/NovoPei/index'));

export const routesConfig: RouteConfig[] = [
  {
    path: '/error',
    element: <ErrorPage />,
    name: 'Página de erro',
    parent: null,
  },
  {
    path: '/',
    element: <Home />,
    name: 'Cosmos',
    parent: null,
    label: 'Home',
    icon: <Icon size="sm" name="Home" />,
    showInNavBar: true,
  },
  {
    path: '/history',
    element: <History />,
    name: 'Histórico',
    parent: '/',
    label: 'Histórico',
    icon: <Icon size="sm" name="History" />,
    showInNavBar: true,
  },
  {
    path: '/chat?tipo=avaliar',
    element: <Chat />,
    name: 'Avaliar',
    parent: null,
    label: 'Avaliar',
    icon: <Icon name="ExternalEvaluations" size="sm" />,
    showInNavBar: true,
    feature: 'avaliar',
    blockedForProfiles: ['student', 'education_childhood'],
  },
  {
    path: '/chat?tipo=personalizar',
    element: <Chat />,
    name: 'Personalizar',
    parent: null,
    label: 'Personalizar',
    icon: <Icon name="EditCourse" size="sm" />,
    showInNavBar: true,
    feature: 'personalizar',
    blockedForProfiles: ['student', 'education_childhood'],
  },
  {
    path: '/chat?tipo=planejar',
    element: <Chat />,
    name: 'Planejar',
    parent: null,
    label: 'Planejar',
    icon: <Icon name="FileActionPlan" size="sm" />,
    showInNavBar: true,
    feature: 'planejar',
    blockedForProfiles: ['student', 'education_childhood'],
  },
  {
    path: '/chat?tipo=analisar',
    element: <Chat />,
    name: 'Analisar',
    parent: null,
    label: 'Analisar',
    icon: <Icon name="Results" size="sm" />,
    showInNavBar: true,
    feature: 'analisar',
    blockedForProfiles: ['student', 'education_childhood'],
  },
  {
    path: '/chat?form=plano-de-aula',
    element: <Chat />,
    name: 'Plano de Aula',
    parent: null,
    label: 'Plano de Aula',
    showInNavBar: false,
    blockedForProfiles: ['student', 'education_childhood'],
  },
  {
    path: '/chat?form=avaliacao',
    element: <Chat />,
    name: 'Avaliação Descomplicada',
    parent: null,
    label: 'Avaliação Descomplicada',
    showInNavBar: false,
    blockedForProfiles: ['student', 'education_childhood'],
  },
  {
    path: '/relatorio-enem',
    element: <RelatorioEnem />,
    name: 'Desempenho Enem',
    parent: null,
    label: 'Desempenho Enem',
    showInNavBar: false,
    feature: 'analisar',
    blockedForProfiles: ['student', 'education_childhood'],
  },
  {
    path: '/chat',
    element: <Chat />,
    name: 'Chat',
    parent: '/',
  },
  {
    path: '/chat/:chatId',
    element: <Chat />,
    name: 'Chat com ID',
    parent: '/',
  },
  {
    path: '/pei',
    element: <ListPEI />,
    name: 'PEI+',
    parent: '/',
    blockedForProfiles: ['student'],
  },
  {
    path: '/pei/:id/chat',
    element: <Chat />,
    name: 'Chat PEI',
    parent: '/pei',
    blockedForProfiles: ['student'],
  },

  {
    path: '/novoPei/create',
    element: <NewPEI />,
    name: 'Criar PEI',
    parent: '/pei',
    blockedForProfiles: ['student', 'education_childhood'],
  },
  {
    path: '/novoPei/:id',
    element: <NewPEI />,
    name: 'Editar PEI',
    parent: '/pei',
    blockedForProfiles: ['student', 'education_childhood'],
  },
];
